import { cn } from '@/lib/utils';
import {
    ClockIcon,
    CurrencyEuroIcon,
    EnvelopeOpenIcon,
    ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

const StatusIcon = ({ invoice }) => {
    if (invoice.payed_at) {
        return (
            <CurrencyEuroIcon
                className={cn(
                    'size-5',
                    invoice.is_credit && 'text-red-700',
                    !invoice.is_credit && 'text-green-700'
                )}
            />
        );
    }

    if (invoice?.mailed_at) {
        return <EnvelopeOpenIcon className='size-5' />;
    }

    if (invoice.status === 1) {
        return <ExclamationTriangleIcon className='size-5 text-orange-700' />;
    }

    return <ClockIcon className='size-5' />;
};

export default StatusIcon;
